<template>
    <vs-popup class="staff-rating-device-popup" title="Device Options" :active.sync="popupDeviceConfig.isOpen">
        <div v-if="deviceList && deviceList.items">
            <div class="h-full overflow-auto">
                <vs-table class="create-table" :data="deviceList.items">
                    <template slot="thead">
                        <vs-th class="w-3/12 text-center center-title">UUID</vs-th>
                        <vs-th class="w-2/12 text-center center-title">NAME</vs-th>
                        <vs-th class="w-2/12 text-center center-title">VERSION</vs-th>
                        <vs-th class="w-3/12 text-center center-title">LAST LOGIN</vs-th>
                        <vs-th class="w-2/12 text-center center-title">ACTION</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td class="text-center border-left-custom border-top-custom" :data="tr.device_id">{{tr.device_id}}</vs-td>
                            <vs-td class="text-center border-left-custom border-top-custom" :data="tr.device_name">{{tr.device_name}}</vs-td>
                            <vs-td class="text-center border-left-custom border-top-custom" :data="tr.device_version">{{tr.device_version}}</vs-td>
                            <vs-td class="text-center border-left-custom border-top-custom">
                                <div v-if="tr.last_login_at">
                                    <p class="text-center">{{changeFormat(tr.last_login_at)}}</p>
                                    <p class="text-center">{{getTime(tr.last_login_at)}}</p>
                                </div>
                                <div class="text-center" v-else>N/A</div>
                            </vs-td>
                            <vs-td class="text-center border-left-custom border-top-custom">
                                <img src="../../../assets/images/trash-icon.png" class="cursor-pointer trash-icon" @click="popupDeleteActive = true, activeDevice = tr" />
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <vs-popup class="holamundo delete-survey-review-popup delete-device-popup" :title="`Delete Device`" :active.sync="popupDeleteActive">
                    <div class="text-center">
                        <h3>Do you want to delete this device?</h3>
                        <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                        <vs-button class="mr-6 align-center delete-responsive" @click="removeDevice()">Delete</vs-button>
                        <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupDeleteActive = false">Cancel</vs-button>
                        </div>
                    </div>
                </vs-popup>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import moment from 'moment';
import {changeFormatHelper} from '../../../helper/datetimeHelper';
export default {
    name: 'staff-rating-device-popup',
    props: {
        popupDeviceConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            popupDeleteActive: false,
            activeDevice: null,
            isOpenLoading: false
        }
    },
    computed: {
        deviceList() {
            return this.$store.getters['reviewList/deviceList'];
        }
    },
    watch: {
       popupDeviceConfig: {
           immediate: true,
           deep: true,
           handler() {
               if(this.popupDeviceConfig.isOpen) {
                   document.body.classList.add('overflow-hidden');
               } else {
                   document.body.classList.remove('overflow-hidden');
               }
           }
       } 
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
              container: '#app',
              scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Delete Device Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        removeDevice() {
            if(this.activeDevice) {
                let obj = {
                    id: this.activeDevice.id
                }
                if(!this.isOpenLoading) {
                    this.openLoadingInDiv();
                }
                this.$store.dispatch('reviewList/DELETE_DEVICE', obj).then(() => {
                    this.popupDeleteActive = false;
                    this.$store.dispatch('reviewList/GET_DEVICE_LIST').then(() => {
                        this.closeLoading();
                        this.$vs.notify({
                            title:'Notification',
                            text:'Delete Device Success',
                            color:'success',
                            position:'top-right'})
                    }).catch((err) => {
                        console.log('Error: ' + err);
                    })
                }).catch((err) => {
                    this.popupDeleteActive = false;
                    console.log('Error: ' + err);
                })
            }
        },
        getTime(date) {
            return moment(date).format('hh:mm A');
        },
        changeFormat(date) {
            if(date) {
                return changeFormatHelper(date);
            } else {
                return 'N/A';
            }
        },
    }
}
</script>

<style lang="scss">
.con-vs-popup {
    &.staff-rating-device-popup {
        .vs-popup {
            width: 800px;
            .vs-popup--content {
                margin: 0;
                width: unset;
                min-height: 300px;
                .vs-con-table .vs-con-tbody {
                    border: none;
                    .vs-table--thead {
                        border-bottom: 1px solid #aaa;
                    }
                }
            }
        }
        .trash-icon {
            width: 16px;
        }
    }

    &.delete-device-popup {
        z-index: 89999;
    }
}
</style>